<template>
    <div class="">
        <div class="w-full h-[32em] bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/paryaschie-potolki-scaled.jpg')] mb-6"></div>

        <h3 class="text-dim_dark text-xl font-bold mb-6">Парящие потолки</h3>

        <button class="px-20 w-full rounded py-4 text-xl text-black bg-dim_gold_2 border border-solid border-dim_gold_2 hover:border-black hover:bg-transparent">Смотреть работы</button>
    </div>
</template>
